var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {GetStatisticsAsync as InvokeAsync , GetStatisticsSync as InvokeSync}

async function GetStatisticsAsync(LoginToken,LastKey)
{
    var GetStatisticsPromise = new Promise((resolve, reject) => {
        GetStatisticsSync(LoginToken,LastKey,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await GetStatisticsPromise;
}

function GetStatisticsSync(LoginToken,LastKey,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/GetStatistics',                
        data  : {
            AppID     :KEYS.AWS_APPID,
            LastKey   :LastKey,
            LoginToken:LoginToken             
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
